import React, { Component } from "react";
import { connect } from "react-redux";
import NotificationAlert from "react-notification-alert";
import {
  Card, Button, CardFooter, CardBody, FormGroup, Input, Container, Col, Form, FormFeedback, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { login } from './../actions/auth';
import 'bootstrap/dist/css/bootstrap.css';
import '../../src/assets/css/login.css';
import '../../src/assets/img/plugo-logo.png';
import ForgotPassword from  './Authentication/forgotPassword/index.js';
import { Typography } from "@material-ui/core";
import Box from '@material-ui/core/Box';
class Login extends Component {
  state = {
    mobile: "",
    password: "",
    mobileState: "",
    passwordState: "",
    loading: false,
    countryCode: '',
    isForgotPassword:false
  }
  componentDidMount() {
    console.log('ayega');
    if (process.env.REACT_APP_ACTIVE_REGION == "europe") {
      this.setState({
        countryCode: ''
      })
    }
    else {
      this.setState({
        countryCode: ''
      })
    }
  }
  selectCountryCode = (e) => {
    this.setState({
      countryCode: e.target.value
    })
  }
  componentWillReceiveProps(props) {
    if (!props.resStatus && props.resMessage) {
      this.setState({ loading: false })
      let options = {
        place: "tc",
        message: '  ' + props.resMessage,
        type: "warning",
        icon: "fas fa-exclamation-triangle",
        autoDismiss: 4
      };
      if (this.refs.notificationAlert.state.notifyTC.length < 1) {
        this.refs.notificationAlert.notificationAlert(options);
      }
    }
  }

  verifyLength = (value, length) => {
    if (value.length >= length) {
      return true;
    }
    return false;
  };
  verifyMobileNo = value => {
    
      return true;
   
  }

  change = (event, stateName, type) => {
    switch (type) {
      case "mobile":
        if (this.verifyMobileNo(event.target.value)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 5)) {
          this.setState({ [stateName + "State"]: "has-success" });
        } else {
          this.setState({ [stateName + "State"]: "has-danger" });
        }
        break;
      default:
        break;
    }
    this.setState({ [stateName]: event.target.value });
  }


  handleSubmit = (e) => {
    e.preventDefault()
    if (this.state.mobileState === "has-success" && this.state.passwordState === "has-success") {
      this.setState({ loading: true })
      this.props.login({
        username: this.state.countryCode + this.state.mobile,
        password: this.state.password,
        Language: this.props.locale
      }).then(res=>console.log({res},'login res'))
      let {resMessage,resStatus} = this.props;
    
    } else if (this.state.mobileState === "" && this.state.passwordState === "") {
      this.setState({ mobileState: "has-danger" });
      this.setState({ passwordState: "has-danger" });
    } else if (this.state.mobileState === "") {
      this.setState({ mobileState: "has-danger" });
    } else if (this.state.passwordState === "") {
      this.setState({ passwordState: "has-danger" });
    }
  }
  handleForgotPassword =()=>{
    this.setState({isForgotPassword:!this.state.isForgotPassword});
  }

  render() {
    let { mobileState, passwordState } = this.state
   
    return (
      <React.Fragment>
      {!(this.state.isForgotPassword) ? (
      <div className="content">
        {this.state.loading ? <div className="loading-spinner" /> : ""}
        <div className="rna-container">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <Container>
          <Col className="ml-auto mr-auto" lg="4" md="6">
         
            <Form className="form" onSubmit={this.handleSubmit}>
              <div className="login-form">            
                <Card className="login-card">
                  <div>
                    <img
                      src="./plugo-logo.png"
                      style={{
                        width: "70%",
                        display: "block",
                        margin: "0 auto",
                        paddingBottom: "40px",
                        paddingTop:"40px",
                      }}
                      alt="Logo"
                    />
                  </div>
                  <CardBody>
                    <FormGroup className={`has-label ${mobileState}`}>
                      <label>Username/Email *</label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText
                            style={{ border: "1px solid #E9ECEF" }}
                          >
                            <i className="fas fa-user" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          name="mobile"
                          autoComplete="off"
                          valid={mobileState === "has-success"}
                          invalid={mobileState === "has-danger"}
                          placeholder="Username/Email"
                          onChange={(e) =>
                            this.change(e, "mobile", "mobile")
                          }
                          style={{ border: "1px solid #ffffff" }}
                          autoCapitalize="off"
                        />
                      </InputGroup>
                      <FormFeedback
                        valid={mobileState === "has-success"}
                        invalid={mobileState === "has-danger"}
                      >
                        {this.state.mobileState === "has-danger" ? (
                          "Mobile No is required."
                        ) : (
                          <span />
                        )}
                      </FormFeedback>
                    </FormGroup>
                    <FormGroup className={`has-label ${passwordState}`}>
                      <label>Password *</label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText
                            style={{ border: "1px solid #E9ECEF" }}
                          >
                            <i className="fas fa-lock" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          id="password"
                          name="password"
                          type="password"
                          autoComplete="off"
                          placeholder="Enter Your Password"
                          valid={passwordState === "has-success"}
                          invalid={passwordState === "has-danger"}
                          onChange={(e) =>
                            this.change(e, "password", "password")
                          }
                          style={{ border: "1px solid #ffffff" }}
                        />
                      </InputGroup>
                      <FormFeedback
                        valid={passwordState === "has-success"}
                        invalid={passwordState === "has-danger"}
                      >
                        {this.state.passwordState === "has-danger" ? (
                          "Password is required."
                        ) : (
                          <span />
                        )}
                      </FormFeedback>
                    </FormGroup>
                    <Box
                      alignItems="center"
                      display="flex"
                      flexDirection="row"
                      justifyContent="flex-end"
                     
                    >
                      
                      {/* <Button variant='text' onClick={() => this.handleForgotPassword()}>
                      Forgot password?
                </Button> */}
                      <Typography  onClick={() => this.handleForgotPassword()}>
                      Forgot password?
                      </Typography>
                      {/* <Link
                        component={RouterLink}
                        to="/account/recover-password"
                      >
                        <b>{t("Forgot password?")}</b>
                        <b>{isSubmitting}</b>
                      </Link> */}
                    </Box>
                  </CardBody>
                  <CardFooter>
                    <FormGroup>
                      <Button
                        block
                        color="success"
                        size="lg"
                        disabled={
                          !(
                            mobileState === "has-success" &&
                            passwordState === "has-success"
                          )
                        }
                      >
                        Login
                      </Button>
                    </FormGroup>
                  </CardFooter>
                </Card>              
              </div>
            </Form>
          
          </Col>
        </Container>
      </div>
        ) :(
          <ForgotPassword handleForgotPassword={this.handleForgotPassword}/>
        ) }
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  return ({
    resMessage: state.auth.resMessage,
    resStatus: state.auth.resStatus
  })
}

export default connect(mapStateToProps, { login }, null, { pure: false })(Login);